import radium from 'radium';
import { connect } from 'react-redux';
import AddressForm from './AddressForm.jsx';
import ZigZagBox from '../../../components/zig-zag-box/ZigZagBox.jsx';
import ZigZagBoxTitle from '../../../components/zig-zag-boxTitle/ZigZagBoxTitle.jsx';
import Checkbox from '../../../components/checkbox/Checkbox.tsx';
import formService from '../../../lib/form-service';
import {
	updateShipmentAddress,
	updateLegalAddress,
	updateAddressesDiffer,
} from '../../../redux/customerReducer';

function CustomerAddressZone(props) {
	const style = {
		addressesDiffer: {
			margin: '0.5em 0 1em',
		},
		legalAddress: {
			margin: '2em 0 0',
		},

	};

	return (
		<ZigZagBox>
			<ZigZagBoxTitle headlineLevel={"h2"} id={'shipping-address-form-title'}>
				Versandadresse
			</ZigZagBoxTitle>
			<AddressForm
				type={"shipping"}
				autoCompleteType="shipping"
				address={props.shipmentAddress}
				errors={props.shipmentErrors}
				onChange={props.shipmentAddressOnChange}

			/>
			<Checkbox
				name="addressesDiffer"
				value="ADDRESSES_DIFFER"
				onChange={props.updateAdressesDiffer}
				checked={props.addressesDiffer}
				label="Abweichende Rechnungsadresse"
				style={style.addressesDiffer}
			/>
			{props.addressesDiffer ?
				(
					<div style={style.legalAddress}>
						<ZigZagBoxTitle headlineLevel={"h2"}>
							Rechnungsadresse
						</ZigZagBoxTitle>
						<AddressForm
							type={"billing"}
							autoCompleteType="billing"
							errors={props.legalErrors}
							address={props.legalAddress}
							onChange={props.legalAddressOnChange}
							hideAdditionalInfoForAddressForm={!props.showLegalAddressAdditionalDropDown}
						/>
					</div>
				) : null
			}
		</ZigZagBox>
	);
}

const RadiumCustomerAddressZone = radium(CustomerAddressZone);

// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state) => ({
	shipmentAddress: state.customer.shipmentAddress,
	legalAddress: state.customer.legalAddress,
	addressesDiffer: state.customer.addressesDiffer,
	showLegalAddressAdditionalDropDown: state.customer.showLegalAddressAdditionalDropDown,
	shipmentErrors: state.eventPage.errors.filter(it => it.startsWith('shipment_'))
		.map(it => it.replace('shipment_', '')),
	legalErrors: state.eventPage.errors.filter(it => it.startsWith('legal_'))
		.map(it => it.replace('legal_', '')),
});

const mapDispatchToProps = (dispatch) => ({
	updateAdressesDiffer: (event) => {
		dispatch(updateAddressesDiffer(event.target.checked));
	},
	shipmentAddressOnChange: (event) => {
		const value = formService.formatSpecificFieldValues(event.target.name, event.target.value);
		dispatch(updateShipmentAddress(event.target.name, value));
	},
	legalAddressOnChange: (event) => {
		const value = formService.formatSpecificFieldValues(event.target.name, event.target.value);
		dispatch(updateLegalAddress(event.target.name, value));
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RadiumCustomerAddressZone);
